/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ProfileRewardsOverviewResponse } from '../models';
/**
 * ProfileRewardsApiApi - axios parameter creator
 */
export const ProfileRewardsApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileRewardsApiGetProfileRewards: async (orgId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orgId' is not null or undefined
            assertParamExists('profileRewardsApiGetProfileRewards', 'orgId', orgId)
            const localVarPath = `/org/{org_id}/profile-rewards`
                .replace('{org_id}', encodeURIComponent(String(orgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileRewardsApiApi - functional programming interface
 */
export const ProfileRewardsApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileRewardsApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} orgId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileRewardsApiGetProfileRewards(orgId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileRewardsOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileRewardsApiGetProfileRewards(orgId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileRewardsApiApi.profileRewardsApiGetProfileRewards']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileRewardsApiApi - factory interface
 */
export const ProfileRewardsApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileRewardsApiApiFp(configuration)
    return {
        /**
         * 
         * @param {ProfileRewardsApiApiProfileRewardsApiGetProfileRewardsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileRewardsApiGetProfileRewards(requestParameters: ProfileRewardsApiApiProfileRewardsApiGetProfileRewardsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProfileRewardsOverviewResponse> {
            return localVarFp.profileRewardsApiGetProfileRewards(requestParameters.orgId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for profileRewardsApiGetProfileRewards operation in ProfileRewardsApiApi.
 */
export interface ProfileRewardsApiApiProfileRewardsApiGetProfileRewardsRequest {
    readonly orgId: string
}

/**
 * ProfileRewardsApiApi - object-oriented interface
 */
export class ProfileRewardsApiApi extends BaseAPI {
    /**
     * 
     * @param {ProfileRewardsApiApiProfileRewardsApiGetProfileRewardsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public profileRewardsApiGetProfileRewards(requestParameters: ProfileRewardsApiApiProfileRewardsApiGetProfileRewardsRequest, options?: RawAxiosRequestConfig) {
        return ProfileRewardsApiApiFp(this.configuration).profileRewardsApiGetProfileRewards(requestParameters.orgId, options).then((request) => request(this.axios, this.basePath));
    }
}

